import React from "react";

// Taken from https://codepen.io/tmrDevelops/pen/yyprGq
export default props => (
  <g transform={"translate(60)"} className="typing-text-wrapper">
    <path id={"typing-text-path-" + props.number} d="m0,110 h0" />
    <text
      fontSize={props.fontSize ? props.fontSize : "20px"}
      id={"typing-text-" + props.number}
      fill={props.color ? props.color : "white"}
    >
      <textPath xlinkHref={"#typing-text-path-" + props.number}>
        {props.content}
      </textPath>
    </text>
  </g>
);



// WEBPACK FOOTER //
// ./src/components/Text/TypingText.js